import React, {useRef} from 'react';
import DrawCanvas, {DrawCanvasHandle} from './DrawCanvas';

interface Props {
    label: string;
    prompt: string;
    warning?: string;
    submitLabel?: string;
    onSubmit: (dataUrl: string) => void;
}

const DrawPromptCard: React.FC<Props> = ({label, prompt, warning, submitLabel, onSubmit}) => {
    const canvasRef = useRef<DrawCanvasHandle>(null);
    return (
        <div className="GmCard">
            {warning && <p className="GmHint GmHint--warn">{warning}</p>}
            <h3 className="GmCard-title">{label}</h3>
            <p className="GmRoleLocation" style={{marginBottom: 12}}>{prompt}</p>
            <DrawCanvas ref={canvasRef}/>
            <div className="GmBtnRow" style={{marginTop: 12}}>
                <button className="GmBtn" onClick={() => canvasRef.current?.clear()}>Очистить</button>
                <button
                    className="GmBtn GmBtn--primary"
                    onClick={() => {
                        const dataUrl = canvasRef.current?.toDataURL();
                        if (dataUrl) onSubmit(dataUrl);
                    }}
                >{submitLabel || 'Готово, передать дальше'}</button>
            </div>
        </div>
    );
};

export default DrawPromptCard;
